import React from "react";
import { SnackbarProvider } from "notistack";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

export const NotifyProvider: React.FC = ({ children }) => {
  const notistackRef = React.createRef<any>();
  const onClickDismiss = (key) => () => {
    if (notistackRef && notistackRef.current) {
      notistackRef.current.closeSnackbar(key);
    }
  };

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={1}
      autoHideDuration={7000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      action={(key) => (
        <IconButton color="inherit" onClick={onClickDismiss(key)}>
          <CloseIcon color="inherit" />
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};
